export const SERVER_ERROR_MESSAGE =
  'エラーが発生しました\r\n時間をおいてもう一度お試しください。';

export const VENDOR_API_PREFIX = '/vendors';
